import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Timer } from './Timer';

export class ThirdModel extends Component {
    displayName = ThirdModel.name

    constructor(props) {
        super(props);
        this.state = {
            currentCount: 0,
            name: "",
            core: "",
            category: "Здоровье и фитнес",
            topn: 100,
            result: "",
            loading: false,
            button: "Результаты",
            minutes: 0,
            seconds: 0,
            serviceType: 0
        };
        this.incrementCounter = this.incrementCounter.bind(this);
        this.setName = this.setName.bind(this);
        this.setCore = this.setCore.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setTopn = this.setTopn.bind(this);
        this.getResult = this.getResult.bind(this);
        this.start = this.start.bind(this);
        this.setDescriptionModel = this.setDescriptionModel.bind(this);
        this.setCoreModel = this.setCoreModel.bind(this);
    }

    //componentDidMount() {
    //    this.myInterval = setInterval(() => {
    //        const { seconds, minutes } = this.state

    //        if (seconds > 0) {
    //            this.setState(({ seconds }) => ({
    //                seconds: seconds - 1
    //            }))
    //        }
    //        if (seconds === 0) {
    //            if (minutes === 0) {
    //                clearInterval(this.myInterval)
    //            } else {
    //                this.setState(({ minutes }) => ({
    //                    minutes: minutes - 1,
    //                    seconds: 59
    //                }))
    //            }
    //        }
    //    }, 1000)
    //}

    //componentWillUnmount() {
    //    clearInterval(this.myInterval)
    //}
    start() {
        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            //if (seconds > 0) {
            this.setState(({ seconds }) => ({
                seconds: seconds + 1
            }))
            //}
            if (seconds === 59) {
                //if (minutes === 0) {
                //    clearInterval(this.myInterval)
                //} else {
                this.setState(({ minutes }) => ({
                    minutes: minutes + 1,
                    seconds: 0
                }))
                //}
            }
        }, 1000)
    }
    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    setName(str) {
        this.setState({ name: str });
    }
    setCore(str) {
        this.setState({ core: str });
    }
    setCategory(str) {
        this.setState({ category: str });
    }
    setTopn(str) {
        this.setState({ topn: str });
    }
    setDescriptionModel(e) {
        this.setState({ serviceType: 0 });
    }
    setCoreModel(e) {
        this.setState({ serviceType: 1 });
    }

    getResult() {
        this.setState({ loading: true, button: "..Progress", seconds: 0, minutes: 0 });
        this.start();
        fetch('api/model/third', {
            method: 'post',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                name: this.state.name,
                core: this.state.core,
                category: this.state.category,
                topN: this.state.topn,
                serviceType: this.state.serviceType
            })
        }).then(response => response.json())
            .then(data => {
                this.setState({ result: data.result, loading: false, button: "Результаты" });
                clearInterval(this.myInterval);
            });
    }

    render() {
        return (
            <div className="col-md-12">
                <h2>Документация по исходному коду и развертыванию системы</h2>
                <div className="row form-group">
                    <div className="col-md-1">
                        <p>GitHub:</p>
                    </div>
                    <div className="col-md-2">
                        <a href="https://github.com/Statanly/LifeRu" className="stretched-link">Исходный код</a>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-3">
                        <p>Техническая документация:</p>
                    </div>
                    <div className="col-md-2">
                        <a href="#" className="stretched-link">Документация</a>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-3">
                        <p>Презентация проекта:</p>
                    </div>
                    <div className="col-md-2">
                        <a href="#" className="stretched-link">Презентация</a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ThirdModel.js